import { partnerReducer } from "../reducer/PartnerReducer";

export const reducer = partnerReducer;